import React from "react";
import { useLanguage } from "../App";
import { Facebook, Instagram, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  const { t } = useLanguage();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold bg-gradient-to-r from-yellow-400 to-amber-300 bg-clip-text text-transparent">
              DAKHLA KITE PLANET
            </h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              {t.footer.description}
            </p>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-yellow-400 transition-colors"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-yellow-400 transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-400">
              {t.footer.quickLinks}
            </h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection("home")}
                  className="text-gray-300 hover:text-yellow-400 transition-colors text-sm"
                >
                  {t.nav.home}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("lessons")}
                  className="text-gray-300 hover:text-yellow-400 transition-colors text-sm"
                >
                  {t.nav.lessons}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("packages")}
                  className="text-gray-300 hover:text-yellow-400 transition-colors text-sm"
                >
                  {t.nav.packages}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("about")}
                  className="text-gray-300 hover:text-yellow-400 transition-colors text-sm"
                >
                  {t.nav.about}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("contact")}
                  className="text-gray-300 hover:text-yellow-400 transition-colors text-sm"
                >
                  {t.nav.contact}
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-400">
              {t.nav.contact}
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-gray-300 text-sm">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0 text-yellow-400" />
                <span>Dakhla Lagoon, Morocco</span>
              </li>
              <li className="flex items-center gap-2 text-gray-300 text-sm">
                <Phone className="h-4 w-4 flex-shrink-0 text-yellow-400" />
                <a href="https://wa.me/212667240623" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors">+212 667 240 623</a>
              </li>
              <li className="flex items-center gap-2 text-gray-300 text-sm">
                <Mail className="h-4 w-4 flex-shrink-0 text-yellow-400" />
                <a href="mailto:contact@dakhlakiteplanet.com" className="hover:text-yellow-400 transition-colors">
                  contact@dakhlakiteplanet.com
                </a>
              </li>
            </ul>
          </div>

        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-gray-400 text-sm">
          <p>
            &copy; {new Date().getFullYear()} Dakhla Kite Planet. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
